import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { NationalityDto } from '../../api/fetch-nationalities/fetchNationalities.types';
import type { UseNationalitiesReturn } from './useNationalities.types';

import { fetchNationalities } from '../../api/fetch-nationalities/fetchNationalities';

export function useNationalities(enabled = true): UseNationalitiesReturn {
  const { data = [], isLoading, isError } = useQuery<NationalityDto[], Error>({
    queryKey: ['nationalities'],
    queryFn: fetchNationalities,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled,
  });

  const nationalities = useMemo(() => {
    const seen = new Map<string, NationalityDto>();
    data.forEach(n => {
      if (!seen.has(n.iso2Code)) seen.set(n.iso2Code, n);
    });
    return Array.from(seen.values());
  }, [data]);

  return {
    nationalities,
    isNationalitiesLoading: isLoading,
    isNationalitiesError: isError,
  };
}
